// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__315E_","addWidgetButton":"Header_addWidgetButton__1YsX9","dashboardTabs":"Header_dashboardTabs__12EBC","active":"Header_active__1Msrn"};